import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslateLoader } from '@ngx-translate/core';

declare let require: any;

@Injectable({
  providedIn: 'root'
})
export class MultiTranslateHttpLoaderService implements TranslateLoader {
  constructor(private http: HttpClient) {}

  public getTranslation(language: string): Observable<any> {
    const translationFiles: string[] = this.getSelectedFilePaths(language);
    const requests: any = translationFiles.map((translationFile: string) =>
      this.http.get(`/assets/i18n/${translationFile}`)
    );
    return forkJoin(requests).pipe(map((response: any) => response.reduce((a: any, b: any) => Object.assign(a, b))));
  }

  /**
   *  Get all of the translation file paths ([selectedLang]/[filename].json) for the selected language.
   */
  private getSelectedFilePaths(language: string): string[] {
    const allFiles: string[] = this.getAllFilePaths();
    const languageFiles: string[] = [];
    allFiles.forEach((filePath: string) => {
      if (filePath.startsWith(language, 2)) {
        filePath = filePath.replace(new RegExp(`^./([^.]+)`), (_: string, b: string) => b);
        languageFiles.push(filePath);
      }
    });
    return languageFiles;
  }

  /**
   * Get all of the translation file paths for every languages.
   */
  private getAllFilePaths(): string[] {
    return ((context: any): string[] => context.keys())(require.context(`../../../assets/i18n`, true, /.json/));
  }
}
